import * as types from './actiontypes';

export function setIsStandaloneView(isStandaloneView) {
	return {
		type: types.SET_IS_STANDALONE_VIEW,
		isStandaloneView: isStandaloneView
	};
}